module.exports = __webpack_public_path__ + "img/label.7b61c8c8.svg";